module.exports = __webpack_public_path__ + "img/loginimg.d1befbaa.png";